import React, { useCallback, useEffect, useState } from "react";
// import PersonalInformation from "../PersonalInformation/PersonalInformation";
// import PaymentDetails from "../PaymentDetails/PaymentDetails";
import styles from "./Checkouthome.module.scss";
import { useDispatch, useSelector } from "react-redux";
import queryString from "query-string";
import PaymentOption from "../PaymentOption/PaymentOption";
import { saveOrderDetails } from "../../redux/actions/orderDetails/orderDetailsActions";
import { saveLiveStatus } from "../../redux/actions/liveStatus/liveStatusActions";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import { ToastErrorStyles } from "../../constants/toastStyles";
import { Get, Post } from "../../api/client";
import {
  closeLoader,
  openLoader,
} from "../../redux/actions/loader/loaderActions";
import MerchantDetail from "./MerchantDetail";
import FailedPaymentCard from "../../components/FailedPaymentCard/FailedPaymentCard";
import { Redeem } from "@material-ui/icons";
import transactpay from "../../assets/images/applogo.png";
import twd from "../../assets/images/TWD_final_logo_icon.png";
// import ReactConfetti from "react-confetti";
import SubHeader from "../../components/subHeader/subHeader";
import SelectPaymentMethod from "../../components/SelectPaymentMethod/SelectPaymentMethod";
import { decryptDirectIntegrationPayload } from "../../utils/encrypt-di";
import { camelCaseObjectKeys } from "../../utils/camelCaseObjectKeys";
import encryptForge from "../../utils/encryptForge";
import confetti from "canvas-confetti";
import { commarize } from "../../utils/helpers";

const CheckoutHome = () => {
  // const [paymentLinkDetails, setPaymentLinkDetails] = useState<any>();
  const [createOrderStatus, setCreateOrderStatus] = useState<any>({
    status: "",
    message: "",
  });
  const [isDiscounted, setisDiscounted] = useState(false);
  const [discountAmount, setdiscountAmount] = useState("");
  const dispatch = useDispatch();
  const body = queryString.parse(window.location.search);
  

  const queryPayload = {
    orderId: body?.orderId,
    customer: {
      firstName: body?.firstName,
      lastName: body?.lastName,
      mobile: body?.mobile,
      country: body?.country,
      email: body?.email,
    },
    order: {
      amount: body?.amount,
      reference: body?.reference,
      description: body?.description ?? "checkout",
      currency: body?.currency,
      customValues: body?.customValues ?? null,
    },
    Subsidiary: {
      SendCustomization: null,
    },
    payment: {
      redirectUrl: body?.redirectUrl,
      frequencyId: body?.frequencyId,
      numberOfPayment: body?.numberOfPayment,
      paymentLinkId: body?.paymentLinkId,
    },
  };

  const fetchExistingOrder = async (orderId: string) => {
    dispatch(openLoader("", "default"));
    try {
      const response: any = await Get(`orders/fetch/${orderId}`);
      const data = decryptDirectIntegrationPayload(response?.data?.data);

      const parsedData = JSON.parse(data);
      const camelCasedObjectKeys = camelCaseObjectKeys(parsedData);
      // console.log({ camelCasedObjectKeys });
      if (camelCasedObjectKeys?.subsidiary?.redirectUrl) {
        sessionStorage.setItem(
          "redirectUrl",
          camelCasedObjectKeys?.subsidiary?.redirectUrl,
        );
      }
      setisDiscounted(camelCasedObjectKeys?.isDiscounted);
      setdiscountAmount(camelCasedObjectKeys?.discountAmount);
      sessionStorage.setItem(
        "checkout_current_api_key",
        camelCasedObjectKeys?.keys?.publicKey,
      );
      sessionStorage.setItem(
        "checkout_current_encryption_key",
        camelCasedObjectKeys?.keys?.publicEncryptionKey,
      );

      dispatch(saveOrderDetails({ data: camelCasedObjectKeys }));
      setCreateOrderStatus({
        status: "success",
        message: "Order created successfully",
      });
      updateLiveStatus();
    } catch (error: any) {
      const message =
        error?.response?.data?.Message ??
        error?.response?.data?.message ??
        "Error";
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: message,
        }),
      );
      setCreateOrderStatus({
        status: "failed",
        message: message,
      });
    } finally {
      dispatch(closeLoader());
    }
  };

  const CreateOrder = async () => {
    const orderReference = queryPayload.order.reference as string;
    const createdKey = `checkout-order-created_${orderReference}`;

    if (sessionStorage.getItem(createdKey) === "true") {
      setCreateOrderStatus({
        status: "completed",
        message: "",
      });
      return;
    }

    try {
      dispatch(openLoader("", "default"));

      sessionStorage.setItem("checkout-payment-completed", "");
      const { customValues, ...rest } = queryPayload.order;
      const transformedData = {
        ...queryPayload,
        order: {
          ...rest,
          description: ((queryPayload?.order?.description as string) ?? "")
            ?.replace(/\n/g, " ")
            .replace(/\s+/g, " ")
            .trim()
            .slice(0, 270),
        },
      };

      const key = sessionStorage.getItem("checkout_current_encryption_key");

      const payload = {
        data: encryptForge(JSON.stringify(transformedData), key),
        customFields: customValues,
      };

      console.log(payload);

      const data: any = await Post("payment/order/create", payload, false);
      sessionStorage.setItem(createdKey, "true");
      dispatch(saveOrderDetails(data?.data));
      setCreateOrderStatus({
        status: "success",
        message: "Order created successfully",
      });
      setisDiscounted(data?.data?.data?.isDiscounted);
      setdiscountAmount(data?.data?.data?.discountAmount);
    } catch (error: any) {
      // console.log({ error });

      const message =
        error?.response?.data?.Message ??
        error?.response?.data?.message ??
        "An Error Occurred";
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: message,
        }),
      );
      setCreateOrderStatus({
        status: "failed",
        message: message,
      });
    } finally {
      dispatch(closeLoader());
    }
  };

  const fetchPaymentLink = async () => {
    try {
      // dispatch(openLoader());
      const ppload = { reference: body?.reference };
      const res: any = await Post(
        "payment/paymentlink/get-keys",
        ppload,
        false,
      );

      // console.log({ here: "here..." });

      const data = res?.data?.data;
      // const liveStatus = data?.isLive
      // dispatch(saveLiveStatus(liveStatus))
      sessionStorage.setItem("checkout_current_api_key", data?.publicKey);
      sessionStorage.setItem(
        "checkout_auth_option",
        data?.authOption == "NOAUTH" ? "c1" : "",
      );
      sessionStorage.setItem(
        "checkout_current_encryption_key",
        data?.publicEncryptionKey,
      );
      // localStorage.setItem("isLive",data?.isLive)
      queryPayload.order.reference = data.paymentReference;
      CreateOrder();
    } catch (error: any) {
      const message =
        error?.response?.data?.Message ??
        error?.response?.data?.message ??
        "An Error Occurred";
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: message,
        }),
      );
      setCreateOrderStatus({
        status: "failed",
        message: message,
      });
    } finally {
      dispatch(closeLoader());
    }
  };

  const updateLiveStatus = useCallback(() => {
    const apiKey = sessionStorage.getItem("checkout_current_api_key");
    if (!apiKey) {
      return;
    }
    const TEST = "TEST";
    if (apiKey.toUpperCase().includes(TEST)) {
      dispatch(saveLiveStatus(false));
      return;
    }
    dispatch(saveLiveStatus(true));
  }, [dispatch]);

  // updating live status

  useEffect(() => {
    const alreadyCompleted =
      sessionStorage.getItem("checkout-payment-completed") === "true";
    const trackedReference = sessionStorage.getItem(
      "checkout-tracked-reference",
    );
    const currentReference = body?.reference as string;

    if (alreadyCompleted && trackedReference === currentReference) {
      updateLiveStatus();
      return;
    }

    if (queryPayload?.payment?.redirectUrl) {
      // console.log("set redirect url");

      sessionStorage.setItem(
        "redirectUrl",
        queryPayload?.payment?.redirectUrl as string,
      );
    }
    if (body?.orderId) {
      fetchExistingOrder(body.orderId as string);
      // updateLiveStatus();
    } else if (!!body?.encryptionKey === false) {
      // console.log("Enters here", body?.encryptionKey);

      fetchPaymentLink();
      updateLiveStatus();
    } else {
      if (body.encryptionKey) {
        const encryptionKey = body.encryptionKey?.toString() ?? "";
        const apikey = body.apiKey?.toString() ?? "";

        const isLive = body.isLive?.toString() ?? "";
        const authOption = body.cab?.toString() ?? "";
        document.cookie = `isLive=${String(
          isLive,
        )};path=/;domain=transactpay.ai;secure`; //save isLive to cookie
        sessionStorage.setItem("checkout_current_api_key", apikey);
        sessionStorage.setItem("checkout_auth_option", authOption);
        sessionStorage.setItem(
          "checkout_current_encryption_key",
          encryptionKey,
        );
        sessionStorage.setItem("isLive", String(isLive));

        updateLiveStatus();
        CreateOrder();
      }
    }
  }, [updateLiveStatus]);

  const ErrorBox = (
    <div className={styles.errorMessageBox}>
      <FailedPaymentCard
        message={createOrderStatus.message}
        paymentmethod="any"
      />
    </div>
  );

  // code for discount modalActions
  const [showDiscountModal, setshowDiscountModal] = useState(false);
  const toggleDiscountModal = () => setshowDiscountModal(!showDiscountModal);
  const [confettiActive, setConfettiActive] = useState(true);

  useEffect(() => {
    if (showDiscountModal) {
      const duration = 3 * 1000;
      const end = Date.now() + duration;

      const frame = () => {
        confetti({
          particleCount: 5,
          spread: 70,
          origin: { y: 0.6 },
          zIndex: 9999,
        });

        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      };

      frame();
    }
  }, [showDiscountModal]);

  useEffect(() => {
    if (isDiscounted && Number(discountAmount) > 0) {
      setshowDiscountModal(true);
    } else {
      setshowDiscountModal(false);
    }
  }, [isDiscounted, discountAmount]);

  return (
    <div className={styles.container}>
      {/* <MerchantDetail /> */}
      {/* <SubHeader /> */}
      {/* <SelectPaymentMethod></SelectPaymentMethod> */}
      <div style={{ width: "100%" }}>
        {/* {createOrderStatus.status === "failed" ? ErrorBox : <PaymentOption />} */}
        {createOrderStatus.status === "failed" ? (
          ErrorBox
        ) : (
          <SelectPaymentMethod />
        )}
      </div>

      {/* Discount PopUp Starts */}
      {showDiscountModal && (
        <div className={styles.overlay}>
          {/* <ReactConfetti
            recycle={confettiActive}
            numberOfPieces={confettiActive ? 200 : 0}
          /> */}

          <div className={styles.modal}>
            <div className={styles.leftSide}>
              <Redeem fontSize="large"></Redeem>
              <h2 className={styles.header}>
                Discount: Powered by Transactpay
              </h2>
              <p className={styles.message}>
                Enjoy a ₦{commarize(discountAmount)} instant discount on this
                transaction! Happy Customer Service Week from the payment
                gateway that puts YOU first.
              </p>
              <div className={styles.closeButton} onClick={toggleDiscountModal}>
                Claim My ₦{commarize(discountAmount)} Discount
              </div>
              <div className={styles.poweredByBox}>
                <p className={styles.poweredBy}>Powered by</p>
                <img
                  src={transactpay}
                  style={{ width: "auto", height: "20px", objectFit: "cover" }}
                  alt="Transactpay"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutHome;
